<div class="{{(field.containerClass ? field.containerClass : 'col-md-6 d-inline-flex mb-4')}}">
    <div class="field-input w-100">
        <label class="form-labels">{{field.label}}<span *ngIf="field.required" class="text-danger">*</span></label>
        <div [formGroup]="group">
            <input [disabled]="field.disabled" type="text" [formControlName]="field.name" class="form-control" [placeholder]="field.placeholder"
                [type]="field.inputType" />

        </div>
        <div *ngFor="let validation of field.validations">
            <div *ngIf="group.get(field.name).invalid && (group.get(field.name).dirty || group.get(field.name).touched)"
                class="text-danger">
                <small *ngIf="group.get(field.name).errors[validation.name]">
                    <b>
                        *{{validation.message}}
                    </b>
                </small>
            </div>
        </div>
    </div>
</div>